// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__u9VRI","badge":"tabs_badge__t7lnm","badge-yellow":"tabs_badge-yellow__jz7w6","badge-green":"tabs_badge-green__kAljG","badge-red":"tabs_badge-red__sgJNi"};